// extracted by mini-css-extract-plugin
export default {"modalOverlay":"CaptchaModalComponent_modalOverlay__p1qoY","modalContent":"CaptchaModalComponent_modalContent__04L7b","closeButton":"CaptchaModalComponent_closeButton__IfMpc"};